module.exports = __webpack_public_path__ + "assets/2e03f0142d724cb9db912394d5bb57da.svg";